/**
 * ConnectFirst Service
 */
export class ConnectFirstService {

    constructor(accessToken) {
        this.API_URL = process.env.REACT_APP_API_URL;
        this.accessToken = accessToken;
    }

    async getAllConnectFirst(pageSize, pageNum, accountID) {
        const response = await fetch(
            this.API_URL + `/connectfirst?size=${pageSize}&page=${pageNum}${accountID ? '&account=' + accountID : ''}`,
            {
                headers: {
                    // 'Content-Type': 'application/json',
                    Authorization: `Bearer ${this.accessToken}`
                }
            }
        );
        return response.json();
    }

    async setConnectFirstClient(connectFirstID, clientCopperID) {
        const response = await fetch(this.API_URL + '/connectfirst/setclient', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.accessToken}`
            },
            body: JSON.stringify({
                connectFirstID,
                clientCopperID
            })
        });

        return response.json();
    }
}